module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "EquityImageTextView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EquityImageTextView!./src/pages/Promote/Equity/EquityImageText/index.js
// module id = 2069
// module chunks = 367